import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'stMaxDate',
  standalone: true,
})
export class MaxDatePipe implements PipeTransform {

  transform(dateOne: Date | undefined, dateTwo: Date | undefined): Date {
    let value!: Date;
    if (dateOne && dateTwo) {
      value = new Date(Math.min(dateOne.getTime(), dateTwo.getTime()));
    } else if (dateOne && !dateTwo) {
      value = dateOne;
    } else if (!dateOne && dateTwo) {
      value = dateTwo;
    }
    return value;
  }

}
